import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateSurveyPerformanceMutationVariables = Types.Exact<{
  input: Types.UpdateSurveyPerformanceInput;
}>;


export type UpdateSurveyPerformanceMutation = { updateSurveyPerformance: { success?: boolean | null } };


export const UpdateSurveyPerformanceDocument = /*#__PURE__*/ gql`
    mutation updateSurveyPerformance($input: UpdateSurveyPerformanceInput!) {
  updateSurveyPerformance(input: $input) {
    success
  }
}
    `;

export function useUpdateSurveyPerformanceMutation() {
  return Urql.useMutation<UpdateSurveyPerformanceMutation, UpdateSurveyPerformanceMutationVariables>(UpdateSurveyPerformanceDocument);
};